import React from 'react';
import PropTypes from 'prop-types';
import Imgix from 'react-imgix';

import config from 'config';

const Image = ({ src, className, imgixParams, ...props }) => {
  const url = src.replace(config('/mediaUrls/s3'), config('/mediaUrls/imgix'));

  /* eslint-disable react/prop-types, react/destructuring-assignment */
  if (props.width) props.defaultWidth = props.width;
  if (props.height) props.defaultHeight = props.height;
  /* eslint-enable react/prop-types, react/destructuring-assignment */

  return (
    <Imgix
      src={url}
      className={className}
      imgixParams={{ auto: 'format', fit: 'crop', ...imgixParams }}
      disableLibraryParam
      aggressiveLoad
      {...props}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  imgixParams: PropTypes.shape({}),
};

Image.defaultProps = {
  className: '',
  imgixParams: {},
};

export default Image;
